module.exports = __webpack_public_path__ + "static/media/Girls-Bed2.11634383.webp";